import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { radioButtonDriverFactory } from '../RadioButton/RadioButton.driver';

export interface RadioButtonGroupDriver extends BaseUniDriver {
  isEmpty(): Promise<boolean>;
  clickItemInput(index: number): Promise<void>;
  getItemsCount(datahook: string): Promise<number>;
  getLang(): Promise<string>;
}

export const radioButtonGroupDriverFactory = (
  base: UniDriver,
): RadioButtonGroupDriver => {
  const radiobuttonDriver = radioButtonDriverFactory(base);
  return {
    ...baseUniDriverFactory(base),
    async isEmpty() {
      return radiobuttonDriver.exists();
    },
    clickItemInput(index: number) {
      return base.$$('input').get(index).click();
    },
    async getItemsCount(datahook: string) {
      return base.$$(`[data-hook=${datahook}]`).count();
    },
    async getLang() {
      return base.attr('lang');
    },
  };
};
